import React, { useContext, useEffect } from 'react'
// import Nointernet from '../Content/images/No Internet.png'
import LoRRI_Image from '../Content/images/LoRRI.png'
import mixpanel from 'mixpanel-browser'
import { Urls } from '../Urls'
import { currentRequestTimeStamp, Activity } from '../Constants'
import { UserApiContext } from './UserDetailsContext/UserDetailsContext'

const Maintenance = () => {
    const { userDetails } = useContext(UserApiContext);
    const tryAgain = () => {
        window.location.reload()
    }
    useEffect(() => {
        Activity([{ "screen": "Maintainance Site", "module": "Maintainance Site", "user_activity": `User viewed Site Under Maintainance`, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])

        mixpanel.track(`User viewed Site under maintainance page`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'Site-Maintainance',
            ModuleName: 'Maintainance',
            ActivityLog: 'userViewedSiteUnderMaintainancePage',
            Data: `None`,
            Definition: `User viewed Site under maintainance page`,
            ActivityType: 'event_view',
            UserName: userDetails?.user_name,
            UserEmail: userDetails?.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
    }, [])
    return (
        <div>
            <div>
                <div className="container">
                    <div style={{ textAlign: 'center' }}><img alt="img" src={LoRRI_Image} className="s-img" /></div>

                    <center>
                        <h1>Site Under Maintenance</h1><br />
                        <h3>Thankyou for being patient.</h3>
                        <h3>We are doing some work on the site and will be back shortly.</h3><br />
                        <button style={{ fontSize: "20px" }} className="btn btn-primary" onClick={tryAgain}>Try Again</button>
                    </center>
                </div>

            </div>
        </div>
    )
}

export default Maintenance
